export default __webpack_public_path__ + "static/media/footer-bg.9525032c.mp4";